<template>
  <div class="job-container">
    <cube-sticky :pos="scrollY">
      <cube-scroll :data="listData" :scroll-events="scrollEvents" @scroll="scrollHandler" :options="options"
                   @pulling-down="onPullingDown" @pulling-up="onPullingUp">
        <div class="job-list-wrapper" :style="iosOrAndroidStyle">
          <!-- <div class="online-cv-tip flex-start" v-if="onlineState ">
            <span class="tip-text">您的简历仅自己可见，公开简历获得更多职位</span>
            <button class="tip-btn flex-center" @click="toSetOnlineCv">去公开</button>
            <span class="iconfont iconx" @click="closeTip"></span>
          </div> -->
          <!-- banner图-->
          <div class="job-list-banner" v-if="image">
            <img :src="image" @click="imgClick"/>
          </div>
          <div class="job-list-header flex-between">
            <div v-for="(item, index) in headerData" :key="index" class="flex-column-center" @click="toPage(item)">
              <img :src="item.icon" alt=""/>
              <span class="job-type-title">{{ item.title }}</span>
            </div>
          </div>
          <cube-sticky-ele>
            <jobsNavBar v-show="iosOrAndroidShow"/>
          </cube-sticky-ele>
          <slot name="container"/>
        </div>
      </cube-scroll>
    </cube-sticky>
    <w-tab-bar page="job" v-show="iosOrAndroidShow"/>
  </div>
</template>

<script>
import jobsNavBar from './job-nav-bar'
import WTabBar from '../../components/global/w-tabbar'
import {mapActions, mapMutations, mapState} from 'vuex'
import { envMixin } from '../../assets/js/mixin/global'
import { userMixin } from '../../assets/js/mixin/user'

const moment = require('moment')

export default {
  name: 'job-container',
  mixins: [ envMixin, userMixin ],
  props: {
    listData: {
      type: Array,
      default: () => []
    },
	  onlineState: {
    	type: [ String, Boolean ],
      default: ''
    }
  },
  data () {
    return {
      scrollY: 0,
      scrollEvents: [ 'scroll' ],
      options: {
        pullDownRefresh: {
          txt: '刷新成功'
        },
        pullUpLoad: true
      },
      headerData: [
        { title: '投递邀约', icon: 'https://files.wondercv.com/jobs/inbox-job.png', path: '/inbox' },
        { title: '我的收藏', icon: 'https://files.wondercv.com/jobs/mailing-job.png', path: '/jobs/mailing' },
        { title: '名企直招', icon: 'https://files.wondercv.com/jobs/company.png', path: '/company/' },
        { title: '求职设置', icon: 'https://files.wondercv.com/jobs/job-setting.png', path: '/job/intentions?jobs=1' }
      ],
      // onlineState: false,
      //  banner 图片
      image: '',
      // banner 跳转地点
      imglink: ''
    }
  },
  mounted () {
    // this.initOnlineState()
    this.getUserData()
    this.bannerImg()
  },
  computed: {
  },
  watch: {},
  components: {
    jobsNavBar,
    WTabBar
  },
  methods: {
    ...mapActions('cv', [ 'getOnlineCvData' ]),
    ...mapMutations('user', [ 'setIsNeedResume' ]),
    closeTip () {
      this.$emit('closeTopTip')
      this._saveLocal()
    },
    // banner图片
    async bannerImg () {
      const { data, code } = await this.$api.jobs.getBannerImg({position: 5})
      if (code === 1000) {
        if(data.length){
          this.image = data[0].image
          this.imglink = data[0].link
        }
      }
    },
    // 点击banner图片跳转
    imgClick(){
      window.location.href = this.imglink
    },
    // 跳转设置在线简历页面
    toSetOnlineCv () {
      this._saveLocal()
      if (this.userData && (!this.userData.match || !this.userData.intention)) {
        this.setIsNeedResume(true)
        this.$fn.jump(
          `${window.location.origin}/template_matches/new`,
          () => {
            this.$router.push('/template_matches/new')
          }
        )
      } else {
        this.$fn.jump(
          `${window.location.origin}/cvs/online/list`,
          () => {
            this.$router.push('/cvs/online/list')
          }
        )
      }
    },
    // 存储localStorage判断顶部tip 7 天不显示
    _saveLocal () {
      let time = moment().format('YYYY-MM-DD')
      this.$db.ls.set(`${ this.cvAccountToken }-jobs-online`, time)
    },
    toPage ({ path }) {
      if (path.includes('company')) {
        this.$fn.jump(`${window.location.origin}${path}`)
      } else {
        this.$fn.jump(`${window.location.origin}${path}`, () => {
          this.$router.push(path)
        })
      }
    },
    scrollHandler ({ y }) {
      this.scrollY = -y
    },
    onPullingUp () {
      this.$emit('onPullingUp')
    },
    onPullingDown () {
      this.$emit('onPullingDown')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
@import '@/assets/scss/global/mixin';
.job-container {
  /*height: calc(var(--vh, 1vh) * 100);*/
  @include ipx-footer(calc(var(--vh, 1vh) * 100), 49px);
  background-color: #F9F9F9;
  .job-list-wrapper {
    .online-cv-tip {
      height: 40px;
      background-color: rgba($color: #FF6644, $alpha: .04);
      padding: 0 14px;
      .tip-text {
        color: #FF6644;
        font-size: $font-size-small;
        margin-right: 14px;
      }
      .tip-btn {
        width: 54px;
        height: 22px;
        border-radius: 12px;
        background-color: #FF6644;
        color: $color-light;
        border: none;
        outline: none;
        margin-right: 12px;
        white-space: nowrap;
      }
      .iconfont {
        color: rgba($color: #FF6644, $alpha: .4);
        font-weight: bold;
      }
    }
    .job-list-banner{
      width: 100%;
      height: 120px;
      padding: 10px 16px;
      //box-sizing: border-box;
      background-color: $color-light;
      img{
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        object-fit: fill;
      }
    }
    .job-list-header {
      height: 98px;
      padding: 18px 20px;
      margin-bottom: 6px;
      background-color: $color-light;
      img {
        width: 42px;
        height: 42px;
        margin-bottom: 10px;
        border-radius: 50%;
        object-fit: contain;
      }
      .job-type-title {
        font-size: $font-size-small;
        color: $color-dark-gray;
      }
    }
  }
  .cube-sticky-ele {
    height: 44px !important;
  }
  ::v-deep .cube-pulldown-loaded {
    color: #9c9c9c;
  }
}
</style>
